import { Link } from "react-router-dom";

import { Avatar } from "./Avatar";
import { PriorityBadge, StatusBadge } from "./StatusBadge";
import { formatRelative, ticketLabel } from "../lib/format";
import type { Ticket } from "../lib/types";

export function AgentTicketRow({ ticket, selected, onSelect }: {
  ticket: Ticket;
  selected: boolean;
  onSelect: () => void;
}) {
  const assignee = ticket.assignee?.name || "Unassigned";
  return <article className={`agent-ticket-row${ticket.unreadCount ? " is-unread" : ""}`}>
    <label className="agent-ticket-row__select">
      <input type="checkbox" checked={selected} onChange={onSelect} aria-label={`Select ticket ${ticketLabel(ticket.number)}`} />
    </label>
    <Link className="agent-ticket-row__subject" to={`/agent/tickets/${ticket.id}`}>
      <span>{ticketLabel(ticket.number)}</span>
      <strong title={ticket.subject}>{ticket.subject}</strong>
      <small>{ticket.lastMessagePreview}</small>
    </Link>
    <span className="agent-ticket-row__person">
      <Avatar name={ticket.requester.name} url={ticket.requester.avatarUrl} size="small" />
      <i>{ticket.requester.name}<small>{ticket.requester.email}</small></i>
    </span>
    <div className="agent-ticket-row__triage">
      <span className="ticket-row-status" aria-label={`Status: ${ticket.status}`}><StatusBadge status={ticket.status} /></span>
      <span className="ticket-row-priority" aria-label={`Priority: ${ticket.priority}`}><PriorityBadge priority={ticket.priority} /></span>
      <span className="ticket-row-assignee">
        <span className="ticket-row-assignee__label">Assignee</span>
        <span className={`ticket-row-assignee__name${ticket.assignee ? "" : " unassigned-label"}`} title={assignee}>{assignee}</span>
      </span>
    </div>
    <time dateTime={ticket.updatedAt}>{formatRelative(ticket.updatedAt)}</time>
  </article>;
}
